<div class="wrapper">
    <div class="mrt-75">
        <div class="page-title">
            <label class="page-caption">Roles</label>
        </div>
        <div class="add-button-box">
            <div class="col-md-12">
                <button (click)="onAddClick()" class="add-button  hand-link">Add Role</button>
            </div>
        </div>
        <div class="container-fluid grid-box" *ngIf="gridOptions && gridOptions.columnDefs">
            <ag-grid-angular class="grid ag-theme-balham"
                [rowData]="gridOptions.rowData" [columnDefs]="gridOptions.columnDefs"
                [defaultColDef]="gridOptions.defaultColDef" [domLayout]="domLayout" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
        <div class="row" *ngIf="gridOptions && rolesList.length === 0">
          <div class="col-12 text-center" style="padding: 40px;">
            <h4>No Roles Found</h4>
          </div>
        </div>
        <ng-template #addRole let-c="close" let-d="dismiss">
            <div class="modal-header blue-bg" style="padding:10px !important;">
                <h2 class="modal-title" style="margin:0px !important" id="modal-basic-title">{{popupHeading}}</h2>
                <button type="button" style="color: white;" class="close" (click)="d('Close click')">&times;</button>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    <label class="name">Role Name</label>
                    <input class="form-control" maxlength="51" type="text" [(ngModel)]="roleName" />
                </div>
                <div class="col-md-12">
                    <p *ngIf="roleName.length==0" class="validation-text">Required</p>
                    <p *ngIf="roleName.length>50" class="validation-text">Role name should be equal or less than 50 characters
                    </p>
                </div>
                <div class="col-md-12">
                    <label class="field-label">Privileges</label>
                    <div *ngIf="privilegesList.length > 0">
                        <div *ngFor="let privilege of privilegesList; let i=index;">
                            <input type="checkbox" name="options" value="{{privilege.id}}" [(ngModel)]="privilege.checked">
                            {{privilege.name}}
                        </div>
                    </div>
                </div>
            </div>
       
        <div class="modal-footer">
            <button type="button" class="btn add-button custom-btn" (click)="saveRole()">Save</button>
            <button type="button" class="btn cancel-btn" (click)="c('Close click')">Cancel</button>
        </div>
       </ng-template>
    
    </div>
    </div>